import React from "react";
import { Box, Button, TextField } from "@mui/material";
import { AddRounded } from "@mui/icons-material";
import { SubClassModel } from "../../../services/decisionFlow";
import { AdminFilterBar, AdminPageHeader, AppModal, DataTable, EmptyState, countLabel } from "../../../components/ui";
import { useManageSubclass } from "./use-manage-subclass";
import { buildSubclassColumns } from "./subclass-columns";

export const ManageSubclass: React.FC = () => {
    const {
        state,
        list,
        modalName,
        setModalName,
        search,
        setSearch,
        filteredRows,
        isEditing,
        handlePageChange,
        handlePageSizeChange,
        handleEnableActive,
        handleNewActive,
        openCreate,
        openEdit,
        closeModal,
    } = useManageSubclass();

    const columns = buildSubclassColumns({ onToggle: handleEnableActive, onEdit: openEdit });
    const total = list.pagination.total;

    return (
        <Box sx={{ width: "100%", p: { xs: "18px 16px 24px", md: 4 } }}>
            <AdminPageHeader
                title="Subclasses"
                subtitle="Agrupamento dos ativos por finalidade."
                action={
                    <Button
                        variant="contained"
                        startIcon={<AddRounded />}
                        onClick={openCreate}
                        sx={{ height: 44, borderRadius: "12px", fontWeight: 600 }}
                    >
                        Nova subclasse
                    </Button>
                }
            />

            <AdminFilterBar search={search} onSearch={setSearch} placeholder="Buscar por nome..." count={countLabel(filteredRows.length, total)} />

            <DataTable<SubClassModel>
                columns={columns}
                rows={filteredRows}
                rowKey={(row) => String(row.id)}
                page={list.pagination.currentPage}
                pageSize={list.pagination.perPage}
                totalRows={list.pagination.total}
                onPageChange={handlePageChange}
                onPageSizeChange={handlePageSizeChange}
                countLabel={countLabel(filteredRows.length, total)}
                emptyState={<EmptyState title="Nenhuma subclasse encontrada" description="Crie uma nova subclasse para começar." />}
            />

            <AppModal
                open={state.open}
                onClose={closeModal}
                kicker={isEditing ? "Editar" : "Cadastrar"}
                title={isEditing ? "Editar subclasse" : "Nova subclasse"}
                maxWidth={440}
                footer={
                    <>
                        <Button variant="outlined" onClick={closeModal} sx={{ height: 40, borderRadius: "10px" }}>
                            Cancelar
                        </Button>
                        <Button
                            variant="contained"
                            onClick={() => handleNewActive(modalName, state.subclass?.id)}
                            sx={{ height: 40, borderRadius: "10px" }}
                        >
                            Salvar
                        </Button>
                    </>
                }
            >
                <TextField
                    fullWidth
                    label="Nome da subclasse"
                    variant="outlined"
                    value={modalName}
                    onChange={(e) => setModalName(e.target.value)}
                    autoFocus
                />
            </AppModal>
        </Box>
    );
};
